<div class="continue-blocker-live-region" role="alert">
  @if (message()) {
    <p class="continue-blocker is-error" [attr.id]="messageId()">{{ message() }}</p>
  }
</div>
